import React from 'react';
import { LucidLoader } from '../Icons';

function WithLoadingHOC({ loading, children, loaderClassName }) {
    return (
        <div className="relative">
            {loading ? (
                <div className={`flex items-center justify-center px-4 py-2 rounded bg-gray-200 cursor-not-allowed ${loaderClassName}`}>
                    <LucidLoader />
                </div>
            ) : (
                children
            )}
        </div>
    );
}
export default WithLoadingHOC;